module.exports = __webpack_public_path__ + "img/bion.bc89b107.png";